import React from 'react';
import { NewnityToolbarContainer } from './newnityToolbarContainer';
import { AdminAppToolbarContainer } from './adminAppToolbarContainer';
import { FromLayoutToolbarProps } from '../layout';

export interface ToolbarProps {
  newnityEnabled: boolean;
}

type Props = ToolbarProps & FromLayoutToolbarProps;

export const Toolbar = (props: Props) => {
  if (props.newnityEnabled) {
    return <NewnityToolbarContainer expandToolbar={props.expandToolbar} toolbarExpanded={props.toolbarExpanded}/>;
  } else {
    return <AdminAppToolbarContainer />;
  }
};